// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"1b511a1e","172":"fb290b64","220":"45ee1650"}[chunkId] + ".css";
};